import React from "react"
import * as s from './css/premium-cosa-puoi-fare.module.css';
import Button from "../../../../components/button";
import acquarioGenova from "../../../../images/partner/logo_acquario_genova.png";
import aquafan from "../../../../images/partner/logo_aquafan.png";
import authreChose from "../../../../images/partner/logo_authre_chose.png";
import helbiz from "../../../../images/partner/logo_helbiz.png";
import notoriusCinema from "../../../../images/partner/logo_notorius_cinema_black.png";
import throwback from "../../../../images/partner/logo_throwback.png";
import cway from "../../../../images/partner/logo_cway.png";
import carrefour from "../../../../images/partner/logo_carrefour.png";
import zalando from "../../../../images/partner/logo_zalando.png";
import booking from "../../../../images/partner/logo_booking.png";
import edreams from "../../../../images/partner/logo_edreams.png";
import obi from "../../../../images/partner/logo_obi.png";
import ca from "../../../../images/partner/logo_ca.png";
import apple from "../../../../images/partner/logo_apple.png";
import primark from "../../../../images/partner/logo_primark.png";
import { isProjectStatusUnavailable } from "../../../../utils/validate-helpers";

const imagesSx = [

    apple,
    booking,
    authreChose,

    primark,
    edreams,
    zalando,

    acquarioGenova,
    aquafan,
    cway,

    helbiz,
    obi,
    throwback,

    carrefour,
    ca,
    notoriusCinema,
]

const PremiumCosaPuoiFare = ({ project, onButtonClick }) => {
    return (
        <div className={`full-container ${s.container}`}>
            <div className="container-grid" style={{ paddingTop: '45px', paddingBottom: '50px' }}>
                <div className="col-span-4 desktop:col-span-6 flex items-center">
                    <div className="mx-4 desktop:mx-0">
                        <div className={`text-primary font-md`} style={{ fontSize: '34px', lineHeight: '40px' }}>Ancora più sconti con Tinaba Premium!</div>
                        <div className={`font-rg text-black`} style={{ fontSize: '16px', lineHeight: '21px', marginTop: '29px' }}>
                            Con Tinaba Premium hai anche accesso ad uno store assolutamente esclusivo che ti offre promozioni e vantaggi su alcuni dei brand più conosciuti. Alcuni esempi? Helbiz, L’ Autre Chose, Carrefour, Booking.com, eDreams, Acquario di Genova, Acquafan, C-Way, Zalando, Obi, Throwback, Notorious Cinemas e molti altri stanno arrivando...
                        </div>
                        <div style={{ marginTop: '30px' }}>
                            <div className="text-center">
                                <div className={`${s.containerButton}`}>
                                    <Button className={`btn-acquista-tinaba-premium ${isProjectStatusUnavailable(project) ? 'opacity-50 cursor-not-allowed' : 'opacity-100 cursor-pointer'}`} disabled={isProjectStatusUnavailable(project)} onClick={() => {
                                        if (onButtonClick) onButtonClick();
                                    }}>
                                        Acquista Tinaba Premium ora
                                    </Button>
                                    {isProjectStatusUnavailable(project) && (<div className="font-rg text-9 text-black" style={{ marginTop: '8px' }}>La prevendita è chiusa</div>)}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`col-span-4 desktop:col-span-5 desktop:col-start-8 flex align-center ${s.containerImage}`}>
                    <div className="grid grid-cols-3 gap-6">
                        {imagesSx.map((img, indexImg) => (
                            <div>
                                {img != null && <img className={`${s.imgLogo}`} src={img} style={{ width: '100%', objectFit: 'contain', maxHeight: '45px' }} alt="partner" />}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PremiumCosaPuoiFare